// extracted by mini-css-extract-plugin
export var active = "_qn-1";
export var circle = "_qn-0";
export var completed = "_qn-2";
export var connector = "_qn-4";
export var connectorCompleted = "_qn-7";
export var connectorSpacer = "_qn-5";
export var iconStrokeOverride = "_qn-8";
export var labelContainer = "_qn-6";
export var pending = "_qn-3";